import { apiGet } from './client'

export interface LoginLogRow {
  id: string
  tenant_id: string
  user_id: string
  ip_address: string | null
  user_agent: string | null
  success: number
  login_at: string
  display_name: string | null
}

export async function fetchLoginLogs(params?: { cursor?: string; limit?: number }) {
  const searchParams = new URLSearchParams()
  if (params?.cursor) searchParams.set('cursor', params.cursor)
  if (params?.limit) searchParams.set('limit', String(params.limit))
  const qs = searchParams.toString()
  return apiGet<{ data: LoginLogRow[]; pagination: { next_cursor: string | null; has_more: boolean } }>(
    `/settings/login-logs${qs ? `?${qs}` : ''}`,
  )
}
